<main class="initial-form">
  <form [formGroup]="formulario" class="initial-form__form">
    <!-- Campo: Nombre -->
    <div class="initial-form__field">
      <label
        for="nombreCliente"
        class="initial-form__label"
        [class.initial-form__label--valid]="isFieldValid('nombreCliente')"
        [class.initial-form__label--invalid]="isFieldInvalid('nombreCliente')">
        *Nombre
      </label>

      <input
        type="text"
        class="initial-form__input"
        formControlName="nombreCliente"
        id="nombreCliente"
        placeholder="Ingresa tu nombre"
        [class.initial-form__input--valid]="isFieldValid('nombreCliente')"
        [class.initial-form__input--invalid]="isFieldInvalid('nombreCliente')"
        (blur)="markFieldAsTouched('nombreCliente')"
        onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)"
        maxlength="40"
      />

      <small class="initial-form__error" *ngIf="shouldShowError('nombreCliente')">
        {{ getErrorMessage('nombreCliente') }}
      </small>
    </div>

    <!-- Campo: Placa -->
    <div class="initial-form__field">
      <label
        for="placa"
        class="initial-form__label"
        [class.initial-form__label--valid]="isFieldValid('placa')"
        [class.initial-form__label--invalid]="isFieldInvalid('placa')">
        *Ingresa el número de tu placa
      </label>

      <input
        type="text"
        class="initial-form__input"
        formControlName="placa"
        id="placa"
        placeholder="Ej:ABC000"
        [class.initial-form__input--valid]="isFieldValid('placa')"
        [class.initial-form__input--invalid]="isFieldInvalid('placa')"
        (blur)="markFieldAsTouched('placa')"
        maxlength="6"
        style="text-transform: uppercase"
      />

      <small class="initial-form__error" *ngIf="shouldShowError('placa')">
        {{ getErrorMessage('placa') }}
      </small>
    </div>

    <!-- Campo: Confirmar Placa -->
    <div class="initial-form__field">
      <label
        for="confirPlaca"
        class="initial-form__label"
        [class.initial-form__label--valid]="isFieldValid('confirPlaca')"
        [class.initial-form__label--invalid]="isFieldInvalid('confirPlaca')">
        *Confirmar el número de tu placa
      </label>

      <input
        type="text"
        class="initial-form__input"
        formControlName="confirPlaca"
        id="confirPlaca"
        placeholder="Ej:ABC000"
        [class.initial-form__input--valid]="isFieldValid('confirPlaca')"
        [class.initial-form__input--invalid]="isFieldInvalid('confirPlaca')"
        (blur)="markFieldAsTouched('confirPlaca')"
        maxlength="6"
        style="text-transform: uppercase"
      />

      <small class="initial-form__error" *ngIf="shouldShowError('confirPlaca')">
        {{ getErrorMessage('confirPlaca') }}
      </small>
    </div>

    <!-- Campo: Celular -->
    <div class="initial-form__field">
      <label
        for="celular"
        class="initial-form__label"
        [class.initial-form__label--valid]="isFieldValid('celular')"
        [class.initial-form__label--invalid]="isFieldInvalid('celular')">
        *Ingresa tu número de celular
      </label>

      <input
        type="text"
        class="initial-form__input"
        formControlName="celular"
        id="celular"
        placeholder="Ej: 3004263078"
        [class.initial-form__input--valid]="isFieldValid('celular')"
        [class.initial-form__input--invalid]="isFieldInvalid('celular')"
        (blur)="markFieldAsTouched('celular')"
        [maxlength]="10"
        autocomplete="off"
        onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
        min="1"
      />

      <small class="initial-form__error" *ngIf="shouldShowError('celular')">
        {{ getErrorMessage('celular') }}
      </small>
    </div>

    <!-- Campo: Ciudad -->
    <div class="initial-form__field">
      <label
        for="ciudadCirc"
        class="initial-form__label"
        [class.initial-form__label--valid]="isFieldValid('ciudadCirc')"
        [class.initial-form__label--invalid]="isFieldInvalid('ciudadCirc')">
        *Ciudad en la que circula tu moto
      </label>

      <input
        name="ciudadCirc"
        #ciudadCirc
        id="ciudadCirc"
        formControlName="ciudadCirc"
        class="initial-form__input initial-form__input--autocomplete"
        [class.initial-form__input--valid]="isFieldValid('ciudadCirc')"
        [class.initial-form__input--invalid]="isFieldInvalid('ciudadCirc')"
        placeholder="Escribe y selecciona una ciudad"
        (blur)="onCiudadBlur()"
        [ngbTypeahead]="search"
        #instance="ngbTypeahead"
      />

      <small class="initial-form__error" *ngIf="shouldShowError('ciudadCirc')">
        {{ getErrorMessage('ciudadCirc') }}
      </small>
    </div>

    <!-- Campos obligatorios -->
    <p class="initial-form__required-note">*Los campos son obligatorios</p>

    <!-- Tipo de uso -->
    <fieldset class="initial-form__fieldset">
      <legend class="initial-form__legend">Tu moto es de uso</legend>

      <div class="initial-form__radio-group">
        <div class="initial-form__radio-item">
          <label class="initial-form__radio-label" for="rbtParticular">
            <input
              class="initial-form__radio-input"
              type="radio"
              name="rbtOption"
              id="rbtParticular"
              checked
              value="particular"
              (change)="radioChangeHandler($event)"
            />
            <span class="initial-form__radio-text">Particular</span>
          </label>
        </div>

        <div class="initial-form__radio-item">
          <label class="initial-form__radio-label" for="rbtComercial">
            <input
              class="initial-form__radio-input"
              type="radio"
              name="rbtOption"
              id="rbtComercial"
              value="comercial"
              (change)="radioChangeHandler($event)"
            />
            <span class="initial-form__radio-text">Comercial</span>
          </label>
        </div>
      </div>
    </fieldset>

    <!-- Componente de asesor -->
    <div class="initial-form__advisor">
      <app-advisor-form
        (advisorSelected)="handleAdvisorSelected($event)"
        (isValid)="handleAdvisorBehavior($event)">
      </app-advisor-form>
    </div>

    <!-- Términos y condiciones -->
    <div class="initial-form__terms">
      <span class="initial-form__terms-text">Al continuar, </span>
      <a class="initial-form__terms-link" (click)="openModal()">
        aceptas términos y condiciones
      </a>
    </div>

    <!-- Botón de envío -->
    <div class="initial-form__submit-container">
      <button
        [disabled]="formularioNoValido || isValidAdvisor()"
        class="initial-form__submit-button"
        [class.initial-form__submit-button--disabled]="formularioNoValido || isValidAdvisor()"
        type="submit"
        (click)="onSubmit()">
        Cotizar
      </button>
    </div>
  </form>
</main>
